import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=b5287d92&scoped=true&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=b5287d92&lang=scss&scoped=true&"
import style1 from "./Toolbar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5287d92",
  null
  
)

export default component.exports